module.exports = __webpack_public_path__ + "files/82e1cb079c032bda3e5b9d3cda671099.png";